

export const ErpConfig: any = {

};
